export default __webpack_public_path__ + "static/media/logo_small.18a58208.png";